import { service } from '@ember/service'
import Component from '@glimmer/component'
import type BookLibraryShare from 'teacher-ui-client/models/book-library/share'
import { ShareStatus } from 'teacher-ui-client/models/book-library/share'
import type { IntlService } from 'ember-intl'

export interface ShareStatusArgs {
  share: BookLibraryShare
}

interface Signature {
  Element: HTMLSpanElement
  Args: ShareStatusArgs
}

export class BookLibraryShareStatus extends Component<Signature> {
  @service intl!: IntlService

  get status(): ShareStatus {
    return this.args.share.status
  }

  get statusText(): string {
    if (this.status === ShareStatus.Active) {
      return this.intl.t('bookLibrary.components.shareStatus.active')
    } else if (this.status === ShareStatus.Pending) {
      return this.intl.t('bookLibrary.components.shareStatus.pending')
    } else if (this.status === ShareStatus.Expired) {
      return this.intl.t('bookLibrary.components.shareStatus.expired')
    } else {
      return this.status
    }
  }

  get statusClass(): string {
    if (this.status === ShareStatus.Active) {
      return 'bg-deep-orange-50 border-deep-orange-350 text-deep-orange-350'
    } else if (this.status === ShareStatus.Pending) {
      return 'bg-oceany-blue-50 border-oceany-blue-350 text-oceany-blue-350'
    } else {
      return 'bg-dusty-black-50 border-dusty-black-300 text-dusty-black-300'
    }
  }

  <template>
    <span class="rounded-full border font-bold uppercase {{this.statusClass}}" ...attributes>
      {{this.statusText}}
    </span>
  </template>
}

export default BookLibraryShareStatus
